import React, { useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import CodeSystemDialogRows from './CodeSystemDialogRows';
import CodeSystemDialogData from './CodeSystemDialogData';
import { GlobalContext } from '../contexts/GlobalContext';
import './CodeSystemDialog.css';
import CodeSystemDialogJson from './CodeSystemDialogJson';
import CodeSystemDialogTags from './CodeSystemDialogTags';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
}));

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={2}>{children}</Box>}
		</div>
	);
}

function CodeSystemDialog(props) {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const globals = useContext(GlobalContext)

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	useEffect(() => {
		globals.initAnalytics();
		globals.logEventAnalytics(
			"CodeSystem",
			"CS - Display Modal",
			props.name);
	}, [globals, props.name])

	function valueCodesLabel(data) {
		if (data.concept === null || data.concept === undefined)
			return (<div>Values  <Chip size='small' label='0' color='secondary' /></div>)

		return (<div>Values  <Chip size='small' label={data.concept.length} color='primary' /></div>)
	}

	function valueMetaDataLabel(data) {
		var count = 0;

		if (data.meta === null || data.meta === undefined)
			return (<div>Metadata  <Chip size='small' label='0' color='secondary' /></div>)

		if (data.meta.tag === null || data.meta.tag === undefined)
			return (<div>Metadata  <Chip size='small' label='0' color='secondary' /></div>)

		count = data.meta.tag.filter(item => item.system === globals.tagSystem).length
		return (<div>Metadata  <Chip size='small' label={count} color='primary' /></div>)
	}

	return (
		<Paper className={classes.root}>
			<Tabs
				value={value}
				onChange={handleChange}
				indicatorColor="primary"
				textColor="primary"
				variant="fullWidth"
			>
				<Tab label="Definition" />
				<Tab label={valueCodesLabel(props)} />
				<Tab label={valueMetaDataLabel(props)} />
				<Tab label="JSON" />

			</Tabs>
			<TabPanel value={value} index={0}>
				<div className="simpleTabPanel">
					<CodeSystemDialogData {...props} />
				</div>
			</TabPanel>
			<TabPanel value={value} index={1}>
				<div className="simpleTabPanel">
					<CodeSystemDialogRows {...props} />
				</div>
			</TabPanel>
			<TabPanel value={value} index={2}>
				<div className="simpleTabPanel">
					<CodeSystemDialogTags {...props} />
				</div>
			</TabPanel>
			<TabPanel value={value} index={3}>
				<div className="simpleTabPanel">
					<CodeSystemDialogJson {...props} />
				</div>
			</TabPanel>
		</Paper>
	);
}

export default CodeSystemDialog;
